module.exports = __webpack_public_path__ + "img/commerce-4.06b18782.jpg";